import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import MovingApartmentBlockData from '../../../Models/Content/MovingApartmentBlockData';
import Moving from './Moving';

export default class MovingApartmentBlock extends EpiComponent<MovingApartmentBlockData> {

  public render(): ReactNode | ReactNodeArray | null {

    let cssClasses: Array<string> = ['moving-apartment-block'];
    // if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    // if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);
    return (
      <div className={cssClasses.join(' ')}>
        <Moving iContent={this.props.data} context={this.getContext()} />
      </div>
    );
  }
}
